import { Navigate, RouteObject } from 'react-router-dom';
import { AuthentifiedLightLayout } from '@layout';
import { SignaturePage } from '@pages';

export const authentifiedLightRoutes = (isLogged: boolean | null | undefined, signature: string | null | undefined): RouteObject[] => [
    {
        element: <AuthentifiedLightLayout />,
        children: [
            {
                path: '/signature',
                element:
                    isLogged && !signature ? (
                        <SignaturePage />
                    ) : isLogged && signature ? (
                        <Navigate to="/home" replace />
                    ) : (
                        <Navigate to="/login" replace />
                    )
            }
        ]
    }
];
